import axios from "axios";
import React, {useEffect, useState} from "react";
import {useParams} from 'react-router-dom';
import {baseUrl, userLocation} from '../Univ.js';
function PoInvoice(props) {
    const {grn_id} = useParams();
    const [opbillData, setopbillData] = useState([]);
    const [distData, setDistData] = useState([]);
    const [hospData, setHospData] = useState([]);
    useEffect(() => {
        // Fetching invoice data
        axios.get(`${baseUrl}grn-invoice/${grn_id}`)
            .then(response => {
                setopbillData(response.data);
                const dis = response.data.dist.id;
                return axios.get(`${baseUrl}edit-distributor/${dis}`);
            })
            .then(response => setDistData(response.data))
            .catch(error => console.log(error));
        // Fetching hospital data
        axios.get(`${baseUrl}view-hospital/${userLocation}/`)
            .then(response => setHospData(response.data))
            .catch(error => console.log(error));
    }, [grn_id, userLocation]);
    const handlePrint = () => {
        const printContents = document.getElementById('invoice-print').innerHTML;
        const originalContents = document.body.innerHTML;
        document.body.innerHTML = printContents;
        window.print();
        setTimeout(() => {
            window.location.reload();
        }, 1000);
        document.body.innerHTML = originalContents;
    };
    function numberToWords(num) {
        const units = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine'];
        const teens = ['eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'];
        const tens = ['', 'ten', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];
        const scales = ['', 'thousand', 'million', 'billion', 'trillion', 'quadrillion', 'quintillion', 'sextillion', 'septillion', 'octillion', 'nonillion', 'decillion', 'undecillion', 'duodecillion', 'tredecillion', 'quattuordecillion', 'quindecillion', 'sexdecillion', 'septendecillion', 'octodecillion', 'novemdecillion', 'vigintillion'];
        function convertThreeDigitsLessThanThousand(num) {
            if (num === 0) return '';
            if (num < 10) return units[num];
            if (num < 20) return teens[num - 11];
            const onesDigit = num % 10;
            const tensDigit = Math.floor((num % 100) / 10);
            const hundredsDigit = Math.floor(num / 100);
            let result = '';
            if (hundredsDigit > 0) {
                result = `${units[hundredsDigit]} hundred`;
            }
            if (tensDigit > 0) {
                if (result) result += ' and ';
                if (tensDigit === 1) {
                    result += teens[onesDigit];
                } else if (onesDigit === 0) {
                    result += tens[tensDigit];
                } else {
                    result += `${tens[tensDigit]}-${units[onesDigit]}`;
                }
            } else if (onesDigit > 0) {
                if (result) result += ' and ';
                result += units[onesDigit];
            }
            return result;
        }
        function convertThreeDigits(num) {
            if (num === 0) return 'zero';
            if (num < 1000) return convertThreeDigitsLessThanThousand(num);
            let words = '';
            let scaleIndex = 0;
            while (num > 0) {
                const currentNum = num % 1000;
                if (currentNum !== 0) {
                    const currentWords = convertThreeDigitsLessThanThousand(currentNum);
                    if (scaleIndex > 0) {
                        words = `${currentWords} ${scales[scaleIndex]} ${words}`;
                    } else {
                        words = `${currentWords} ${words}`;
                    }
                }
                scaleIndex++;
                num = Math.floor(num / 1000);
            }
            return words.trim();
        }
        if (num === 10000) {
            return 'ten thousand rupees only';
        }
        if (num === 0) {
            return 'zero rupees only';
        }
        if (num < 0) return `negative ${numberToWords(Math.abs(num))}`;
        const parts = num.toString().split('.');
        let integerPart = parseInt(parts[0], 10);
        let decimalPart = parseInt(parts[1], 10) || 0;
        let words = '';
        let scaleIndex = 0;
        // Convert integer part
        while (integerPart > 0) {
            const hundreds = integerPart % 1000;
            if (hundreds !== 0) {
                const hundredsWords = convertThreeDigits(hundreds);
                if (scaleIndex !== 0) {
                    words = `${hundredsWords} ${scales[scaleIndex]} ${words}`;
                } else {
                    words = `${hundredsWords} ${words}`;
                }
            }
            scaleIndex++;
            integerPart = Math.floor(integerPart / 1000);
        }
        // Convert decimal part
        if (decimalPart > 0) {
            words += ' and ';
            if (decimalPart < 10) {
                words += units[decimalPart];
            } else if (decimalPart < 20) {
                words += teens[decimalPart - 11];
            } else {
                const onesDigit = decimalPart % 10;
                const tensDigit = Math.floor(decimalPart / 10);
                if (onesDigit === 0) {
                    words += tens[tensDigit];
                } else {
                    words += `${tens[tensDigit]}-${units[onesDigit]}`;
                }
            }
            words += ' paisa';
        }
        words += ' rupees only';
        return words.trim();
    }
    return (
        <section>
            <div>
                {opbillData.map((row, index) => {
                    // Calculate GST total for each row
                    const gstAmountList = row.gstamount.split(',').map(amount => {
                        const value = parseFloat(amount.trim());
                        return value;
                    });
                    const gstTotal = gstAmountList.reduce((total, amount) => total + amount, 0);
                    const roundGrn = Math.round(row.grnamount)
                    return (
                        <div key={index} id="invoice-print">
                       <div
    style={{
        width: "100%",
        margin: 0,
        padding: 0,
        overflow: "hidden",
        lineHeight: 0
    }}
>
    {hospData.map((hospital) => (
        <img
            key={hospital.id}
            src={hospital.logo}
            alt="Hospital Header"
            style={{
                width: "100%",
                height: "110px",
                display: "block",
                margin: 0,
                padding: 0,
                border: "none",
                objectFit: "fill"
            }}
        />
    ))}
</div>

<div
    style={{
        width: "100%",
        margin: "8px 0 0 0",
        padding: "8px 12px",
        boxSizing: "border-box",
        borderTop: "1px solid #333",
        borderBottom: "1px solid #333",
        fontSize: "14px",
        lineHeight: "1.5"
    }}
>
    <div
        style={{
            textAlign: "center",
            fontWeight: "bold",
            marginBottom: "8px"
        }}
    >
        PURCHASE ORDER
    </div>

    <div
        style={{
            display: "flex",
            width: "100%",
            alignItems: "flex-start"
        }}
    >
        <div
            style={{
                width: "55%",
                paddingRight: "15px",
                boxSizing: "border-box",
                borderRight: "1px solid #999"
            }}
        >
            <div style={{ marginBottom: "3px" }}>
                <strong>To :</strong>
            </div>

            <div style={{ marginBottom: "3px" }}>
                <strong>Distributor :</strong>&nbsp;
                {row.dist.name} - {row.dist.person}
            </div>

            <div style={{ marginBottom: "3px" }}>
                <strong>GSTIN :</strong>&nbsp;
                {row.dist.gst}
            </div>

            <div style={{ marginBottom: "3px" }}>
                <strong>Contact :</strong>&nbsp;
                {row.dist.mobile}
            </div>

            <div>
                <strong>Address :</strong>&nbsp;
                {row.dist.address}
            </div>
        </div>

        <div
            style={{
                width: "45%",
                paddingLeft: "15px",
                boxSizing: "border-box"
            }}
        >
            <div style={{ marginBottom: "3px" }}>
                <strong>PO No #:</strong>&nbsp;
                {row.grn_no?.replace("GRN-", "PO-")}
            </div>

            <div>
                <strong>PO Date :</strong>&nbsp;
                {row.grn_date}
            </div>
        </div>
    </div>
</div>
                            <div className="table-responsive">
                                <table border="2" rules="rows" cellpadding="3" className="mt-4" width="100%">
                                    <thead>
                                    <tr style={{borderColor: "#F2F2F2", border: "2px solid black", padding: "8px"}}>
                                        <th align="left">S.No</th>
                                        <th align="left">Product</th>
                                        <th align="left">HSN No</th>
                                        <th align="left">Total Qty</th>
                                        <th align="left">Purchase</th>
                                        <th align="left">SGST %</th>
                                        <th align="left">CGST %</th>
                                        <th align="left">Net Amount</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {row.product.split(',').map((test, subIndex) => (
                                        <tr key={`${index}-${subIndex}`}
                                            style={{border: "2px solid", borderColor: "black"}}>
                                            <td>{index + subIndex + 1}</td>
                                            <td><b>{row.product.split(',')[subIndex].trim()}</b></td>
                                            <td><b>{row.hsn?.split(',')[subIndex].trim()}</b></td>
                                            <td><b>{row.totqty.split(',')[subIndex].trim()}</b></td>
                                            <td><b><i className="fa fa-inr"
                                                      aria-hidden="true"></i>&nbsp;{row.pprice.split(',')[subIndex].trim()}
                                            </b></td>
                                            <td><b>{row.sgst.split(',')[subIndex].trim()}</b></td>
                                            <td><b>{row.cgst.split(',')[subIndex].trim()}</b></td>
                                            <td><b><i className="fa fa-inr"
                                                      aria-hidden="true"></i>&nbsp;{parseFloat(row.netamount.split(',')[subIndex].trim()).toFixed(2)}
                                            </b></td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                                <table border="2" rules="rows" cellpadding="3" className="mt-4" width="100%">
                                    <tbody>
                                    <tr>
                                        <td colSpan="7" style={{border: "2px solid black", padding: "8px"}}></td>
                                        <td style={{border: "2px solid black", padding: "8px", textAlign: 'left'}}>
                                            <b>Amount:</b>
                                        </td>
                                        <td style={{border: "2px solid black", padding: "8px", textAlign: 'left'}}>
                                            <b><i className="fa fa-inr"
                                                  aria-hidden="true"></i>&nbsp;{parseFloat(row.invamount - gstTotal).toFixed(2)}
                                            </b>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan="7" style={{border: "2px solid black", padding: "8px"}}></td>
                                        <td style={{border: "2px solid black", padding: "8px", textAlign: 'left'}}>
                                            <b>GST Total:</b>
                                        </td>
                                        <td style={{border: "2px solid black", padding: "8px", textAlign: 'left'}}>
                                            <b><i className="fa fa-inr"
                                                  aria-hidden="true"></i>&nbsp;{gstTotal.toFixed(2)}</b>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan="7" style={{border: "2px solid black", padding: "8px"}}>
                                            <b>TERMS & CONDITIONS:</b><br/>
                                            <b>PAYMENT TERMS - 60 Days Payment</b>
                                        </td>
                                        <td style={{border: "2px solid black", padding: "8px", textAlign: 'left'}}>
                                            <b>Net Total Amount:</b>
                                        </td>
                                        <td style={{border: "2px solid black", padding: "8px", textAlign: 'left'}}>
                                            <b><i className="fa fa-inr" aria-hidden="true"></i>&nbsp;{roundGrn}</b>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan="7" style={{border: "2px solid black", padding: "8px"}}>
                                            <b>
                                                <p className="text-bold">
                                                    Amount in words : <br></br> {numberToWords(roundGrn)}
                                                </p>
                                            </b>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan="3" style={{border: "2px solid black", padding: "8px"}}>
                                            <b>
                                                <p className="text-bold mt-5 mb-1">
                                                    Prepared By
                                                </p>
                                            </b>
                                        </td>
                                        <td colSpan="3" style={{border: "2px solid black", padding: "8px"}}>
                                            <b>
                                                <p className="text-bold mt-5 mb-1">
                                                    Checked By
                                                </p>
                                            </b>
                                        </td>
                                        <td colSpan="3" style={{border: "2px solid black", padding: "8px"}}>
                                            <b>
                                                <p className="text-bold mt-5 mb-1">
                                                    Authorised Signatory
                                                </p>
                                            </b>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    );
                })}
                <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <button
                        style={{padding: '5px 20px', borderRadius: '10px', backgroundColor: '#007bff', color: '#fff'}}
                        onClick={handlePrint}>
                        Print
                    </button>
                </div>
            </div>
        </section>
    );
}
export default PoInvoice;
